import React from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps {
	children: React.ReactNode;
	className?: string;
	variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'warning';
	onClick?: React.MouseEventHandler<HTMLSpanElement>;
}

export const Badge: React.FC<BadgeProps> = ({ 
	children, 
	className,
	variant = 'default',
	onClick 
}) => {
	const baseClasses = "inline-flex items-center rounded-input px-2.5 py-0.5 font-body text-body-xs font-medium transition-colors duration-200";
	
	const variantClasses = {
		default: "bg-primary text-primary-foreground",
		secondary: "bg-secondary text-secondary-foreground",
		destructive: "bg-destructive text-destructive-foreground",
		outline: "text-foreground border border-input",
		warning: "bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-200"
	};

	return (
		<span onClick={onClick} className={cn(baseClasses, variantClasses[variant], onClick ? 'cursor-pointer' : '', className)}>
			{children}
		</span>
	);
};
